import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../Header/Header";
import Footer from "../../components/Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./Terms.css";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const sections = [

    {
      title: "Effective Date: July 1, 2024",
     
    },
    {
      title: "1. Acceptance of Terms",
      content:
        "By using Larch Technologies' ERP software, you agree to be bound by these terms.",
    },
    {
      title: "2. License to Use",
      content:
        "You are granted a non-transferable license to use the software solely for internal business purposes.",
    },
    {
      title: "3. User Responsibilities",
      list: [
        "You must ensure the confidentiality of login credentials.",
        "You are responsible for the accuracy of data you input into the system.",
      ],
    },
    {
      title: "4. Restrictions",
      list: [
        "No resale, redistribution, or reverse engineering of the software.",
      ],
    },
    {
      title: "5. Limitation of Liability",
      content:
        "Larch Technologies shall not be liable for indirect or incidental damages resulting from software use.",
    },
    {
      title: "6. Support and Maintenance",
      content:
        "We provide technical support during standard business hours, with updates rolled out periodically.",
    },
    {
      title: "7. Termination",
      content:
        "We reserve the right to suspend or terminate access for violation of terms or misuse of the system.",
    },
  ];

  return (
    <div className="terms-page">
      <Header />

      {/* Hero Section */}
      <section className="terms-hero">
        {/* <div className="terms-hero-overlay">
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-date">Effective Date: July 1, 2024</p>
        </div> */}
      </section>

      {/* Main Content */}
      <main className="terms-container">
        {sections.map((sec, idx) => (
          <motion.section
            key={idx}
            className="terms-section"
            variants={fadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{sec.title}</h2>
            {sec.content && <p>{sec.content}</p>}
            {sec.list && (
              <ul>
                {sec.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </motion.section>
        ))}
      </main>

      <Footer />
      <ERPChatbot />
    </div>
  );
}
